import React, { useRef, useState, useEffect } from 'react';
import { Box } from '@mui/system';
import play from 'assets/images/play.svg';

const VideoFrame = ({ fileName, frameSx, videoSx }) => {
    const [playButtonVisibliy, setPlayButtonVisibility] = useState(true);
    const [playbackError, setPlaybackError] = useState('');
    const videoRef = useRef(null);

    const playClickHandler = () => {
        if (videoRef.current) {
            videoRef.current.play().catch((error) => {
                console.error('Error playing video:', error);
            });
        }
    };

    useEffect(() => {
        setPlaybackError('');
    }, [fileName]);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) {
            return undefined;
        }
        video.addEventListener('contextmenu', (event) => event.preventDefault());
        video.addEventListener('dragstart', (event) => event.preventDefault());
        video.addEventListener('drop', (event) => event.preventDefault());
        video.addEventListener('copy', (event) => event.preventDefault());
        video.addEventListener('loadstart', () => {
            video.removeAttribute('download');
        });
        const preventInspect = (event) => {
            if (event.keyCode === 123
                || (event.keyCode === 73 && event.ctrlKey && event.shiftKey)
                || (event.keyCode === 74 && event.ctrlKey && event.shiftKey)
                || (event.keyCode === 85 && event.ctrlKey)) {
                event.preventDefault();
            }
        };
        document.addEventListener('keydown', preventInspect);
        return () => {
            document.removeEventListener('keydown', preventInspect);
        };
    }, [fileName]);

    if (!fileName) {
        return null;
    }

    return (
        <Box
            sx={{
                borderRadius: { xs: 2 },
                overflow: 'hidden',
                display: 'flex',
                background: '#e2e2e2',
                position: 'relative',
                margin: -1,
                minHeight: { xs: '220px', lg: '320px' },
                width: '100%',
                WebkitTransform: 'translateZ(0)',
                transform: 'translateZ(0)',
                userSelect: 'none',
                WebkitUserSelect: 'none',
                MozUserSelect: 'none',
                msUserSelect: 'none',
                '& *': {
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    MozUserSelect: 'none',
                    msUserSelect: 'none',
                },
                '& video': { videoSx },
                ...frameSx,
            }}
            onContextMenu={(event) => event.preventDefault()}
            onDragStart={(event) => event.preventDefault()}
            onSelectStart={(event) => event.preventDefault()}
        >
            <Box
                onClick={playClickHandler}
                sx={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translate(-50%,-50%)',
                    top: '50%',
                    maxWidth: '90px',
                    cursor: 'pointer',
                    zIndex: 2,
                    display: playButtonVisibliy ? 'block' : 'none',
                }}
            >
                <img style={{ maxWidth: '100%' }} src={play} alt="play" />
            </Box>
            <video
                key={fileName}
                src={fileName}
                playsInline
                onPlay={() => setPlayButtonVisibility(false)}
                onPause={() => setPlayButtonVisibility(true)}
                onError={() => {
                    setPlaybackError('امکان پخش ویدیو وجود ندارد. لطفاً فایل را دوباره آپلود کنید.');
                    console.error('Video playback failed:', fileName);
                }}
                ref={videoRef}
                controls
                controlsList="nodownload noremoteplayback"
                disablePictureInPicture
                preload="metadata"
                onContextMenu={(event) => event.preventDefault()}
                onDragStart={(event) => event.preventDefault()}
                onSelectStart={(event) => event.preventDefault()}
                onLoadStart={(event) => {
                    event.target.removeAttribute('download');
                }}
                style={{
                    position: 'relative',
                    left: 0,
                    top: 0,
                    width: '100%',
                    height: '100%',
                    minHeight: '220px',
                    objectFit: 'contain',
                    opacity: 1,
                    transform: 'translateZ(0)',
                    WebkitTransform: 'translateZ(0)',
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    MozUserSelect: 'none',
                    msUserSelect: 'none',
                    pointerEvents: 'auto',
                    ...videoSx,
                }}
            />
            {playbackError ? (
                <Box sx={{
                    position: 'absolute',
                    bottom: 12,
                    left: 12,
                    right: 12,
                    background: 'rgba(0,0,0,0.75)',
                    color: '#fff',
                    p: 1.5,
                    borderRadius: 1,
                    fontSize: 13,
                    zIndex: 3,
                }}>
                    {playbackError}
                </Box>
            ) : null}
        </Box>
    );
};

export { VideoFrame };
